import { render } from "./CertificateAutoLink.vue?vue&type=template&id=033711b4"
import script from "./CertificateAutoLink.vue?vue&type=script&lang=js"
export * from "./CertificateAutoLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__